module.exports = __webpack_public_path__ + "img/数据一体化.ca2e5a40.png";